import dealerApiClient, { tokenStorage } from '../api/dealerApiClient'
import type {
  DealerAuthResponse,
  DealerLoginRequest,
  DealerMe,
  DealerResetPasswordRequest,
} from '../types'

// remember=false — вход только до закрытия браузера (общий компьютер)
export async function login(credentials: DealerLoginRequest, remember = true): Promise<DealerAuthResponse> {
  const { data } = await dealerApiClient.post<DealerAuthResponse>('/auth/login', credentials)
  tokenStorage.set(data.accessToken, data.refreshToken, remember)
  console.log('[INFO] Dealer login successful')
  return data
}

export async function logout(): Promise<void> {
  try {
    await dealerApiClient.post('/auth/logout')
    console.log('[INFO] Dealer logout successful')
  } catch (err) {
    console.error('[ERROR] Dealer logout failed', err)
  } finally {
    tokenStorage.clear()
  }
}

export async function getMe(): Promise<DealerMe> {
  const { data } = await dealerApiClient.get<DealerMe>('/auth/me')
  return data
}

// бэк всегда отвечает 204, чтобы не раскрывать, есть ли такой email
export async function forgotPassword(email: string): Promise<void> {
  await dealerApiClient.post('/auth/forgot-password', { email })
}

// общий эндпоинт для сброса пароля и первичной установки по приглашению
export async function resetPassword(request: DealerResetPasswordRequest): Promise<void> {
  await dealerApiClient.post('/auth/reset-password', request)
}
